import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  Filters,
  FnCaricamentoDati,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import {
  BottoniListaEvent,
  Colonna,
  Filtri,
  ListaTabellareComponent,
} from 'src/app/components/lista-tabellare/lista-tabellare.component';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { ESRS, ESRSService } from 'src/app/services/ESRS/esrs.service';
import { SettoriService } from 'src/app/services/settori/settori.service';
import { UtenteService } from 'src/app/services/utente/utente.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { DialogCreaESRSComponent } from './dialog/dialog-crea-esrs/dialog-crea-esrs.component';

@Component({
  selector: 'app-cfg-esrs',
  standalone: false,

  templateUrl: './cfg-esrs.component.html',
  styleUrl: './cfg-esrs.component.scss',
})
export class CfgEsrsComponent {
  @ViewChild('tabella') tabella!: ListaTabellareComponent;
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public filtri: Filtri[] = [
    {
      titolo: 'Codice',
      forControlName: 'nomeBreve',
      input: 'text',
    },
    {
      titolo: 'Descrizione',
      forControlName: 'descrizione',
      input: 'text',
    },
  ];

  public colonne: { [key: string]: Colonna } = {
    titolo: {
      title: 'Codice',
      value: 'nomeBreve',
      sortable: true,
    },
    descrizione: {
      title: 'Descrizione',
      value: 'descrizione',
      sortable: true,
    },
    modifica: {
      type: 'button',
      buttonIcon: 'edit',
      title: 'Modifica',
      buttonId: 'modifica',
      buttonMostraSempre: true,
      nascondiButton: (record: any) => !this.utenteService.isPermessoAttivo('EDIT_CONFIGURAZIONI'),
    },
    /*   duplica: {
        type: 'button',
        buttonIcon: 'content_copy',
        title: 'Duplica',
        buttonId: 'duplica',
      }, */
    elimina: {
      type: 'button',
      buttonIcon: 'delete',
      title: 'Elimina',
      buttonId: 'elimina',
      nascondiButton: (record: any) =>
        !this.utenteService.isPermessoAttivo('DELETE_CONFIGURAZIONI'),
    },
  };
  constructor(
    public dialog: MatDialog,
    private readonly utilityService: UtilityService,
    private readonly settoriService: SettoriService,
    public utenteService: UtenteService,
    private readonly esrsService: ESRSService,
  ) {}

  /**
   * Apertura dialog filtri passati da l'esterno
   */
  creaNuovoESRS(recordESRS?: ESRS) {
    const dialogCreaESRS = this.dialog.open(DialogCreaESRSComponent, {
      data: {
        esrs: recordESRS,
      },
      panelClass: ['dialog-container-scrollbar'],
      disableClose: false,
      width: '80%',
      maxHeight: '95%',
      height: '95%',
      autoFocus: false,
    });

    dialogCreaESRS.afterClosed().subscribe((result) => {
      this.tabella.caricaDati();
    });
  }

  public fnCaricamentoDati: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    if (!sortBy) {
      sortBy = [
        {
          chiave: 'nomeBreve',
          sort: 'asc',
        },
      ];
    }

    return this.esrsService.getESRS(page, pageSize, ricerca, filters, sortBy);
  };

  public bottoniListaClick(event: BottoniListaEvent) {
    switch (event.id) {
      case 'modifica':
        this.creaNuovoESRS(event.data);
        break;
      case 'elimina':
        this._eliminaESRS(event.data.id);
        break;
      default:
        console.warn('ATTENZIONE: bottone ' + event.id + ' non riconosciuto');
    }
  }

  /**
   * Funzione per eliminare una riga da una lista tabellare
   * @param idRiga id della riga da eliminare
   */
  private _eliminaESRS(idRiga: any) {
    this.utilityService.openDialog({
      descrizione: "Confermi di eliminare l'ESRS?",
      bottoni: [
        {
          nome_btn: 'NO',
          background_color: 'var(--mat-color-accent)',
        },
        {
          nome_btn: 'SI',
          background_color: 'var(--mat-color-primary)',
          handler: () => {
            this.spinnerOver.show();
            this.esrsService.deleteESRS(idRiga).subscribe({
              next: (result: any) => {
                this.tabella.caricaDati();
                this.spinnerOver.hide();
              },
              error: (err: any) => {
                this.spinnerOver.hide();
                this.utilityService.openDialog({
                  titolo: 'Attenzione',
                  descrizione: err.error.message,
                  bottoni: [
                    {
                      nome_btn: 'Chiudi',
                      handler: () => {
                        this.tabella.caricaDati();
                      },
                    },
                  ],
                });
              },
            });
          },
        },
      ],
    });
  }
}
